export default {
    addToCart:(state, row ) => {
        state.cart.push(row)
        state.modified = true
    },
    
    deleteRow:(state, row ) => {
        state.cart = state.cart.filter(r => r.id != row.id)
        state.modified = true
    },

    changeQuantity(state, {row, change}){
        const cartRow = state.cart.find(r => r.id == row.id)
        cartRow.quantity += change
        if(cartRow.quantity<=0){
            state.cart = state.cart.filter(r => r.id != row.id)
        }
        state.modified = true
    },

    cleanOrder(state){
        state.client=null
        state.clientId=null
        state.order = null
        state.cart = []
    },
    cleanCart(state){
        state.cart = []
    },

    setOrder(state, order){
        state.order = order
        state.modified = false
    },
    setCustomerMail(state, email){
        state.email = email
    },

    setClient(state, client){
        if(client){
            state.clientId = client.id
            state.client = client
        }else{
            state.clientId = null
            state.client=null;
        }
    },
    setProducts(state, products){
        state.products = products
    },
    setTaxRate(state, taxRate){
        state.taxRate = taxRate
    },
    setCatalog(state, catalogId){
        state.catalogId = catalogId
    },
    setCategories(state, categories) {
        state.categories = categories
    },
    setPaymentType(state, paymentType) {
        state.paymentType = paymentType
    }
}
